import { isGradePassed, trim, yearsFromNow, daysFromYearsAgo, filterZeroArrays, getCoursesFromColleges, empty, totalCourseCredits, getTotalLoggedHours, handleize, coursesWithCreditsTotal } from '@/lib/utils'
import userMixins from '@/mixins/usersmixin'
export default {
  mixins: [userMixins ],
  computed: {
    hasPacatExam () {
      return Object.values(this.userExams).find(exam => {
       if(exam.exam_type === 'PA-CAT' && exam.examStatus === 'Completed') {
         return true
       }
      })
    },
  }
}


// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkpacatmixin.js